import axios from "axios";
import { defineStore } from 'pinia';
import { ref } from "vue";
import { NetworkTypes } from "@/enums/network";
import { CheckoutLinkService } from "@/core/services/checkoutLinkService";

const api  = axios.create({
    baseURL: 'https://web-app-configuration.s3.eu-west-1.amazonaws.com',
    timeout: 2000
});

const retrieveUserConfiguration = async (user) => {
    try {
        const response = await api.get(`/${user}.json`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const useUserStore = defineStore('user',  () => {
    let data = ref({})


    /*isIm is true for both site and CRM*/
    const isIm = () => {
        return location.hostname.includes("insurancemarket")
    }

    const isPro = () => {
        return location.hostname.includes("insurance-pro")
    }

    const getNetworkType = () => {
        if (isPro()) return NetworkTypes.Pro;
        if (isIm()) return NetworkTypes.InsuranceMarket;
        return NetworkTypes.Affinity;
    }

    const getNetworkName = () => window.location.hostname.replace('www.', '').split('.')[0]

    /* viewer_is_im is a theming-only override */
    const rawViewerIsIm = new URLSearchParams(window.location.search).get('viewer_is_im');
    const viewerIsIm = rawViewerIsIm === '1' || rawViewerIsIm === '0' ? rawViewerIsIm : null;

    /* isProTheme drives the visual pro theme only, the viewer_is_im flag overrides the hostname */
    const isProTheme = () => {
        if (viewerIsIm !== null) {
            return viewerIsIm === '0'
        }

        return false;
    }
    
    const isPanelIFrame = () => {
        return window.location !== top.location && !window.location.hostname.toString().includes('my-pro-office')
    }

    const apiInstance = () => {
        return axios.create({
            headers: {
                'Request-Source': isPanelIFrame() ? 'CRM' : 'SITE',
                'X-Requested-With': 'xmlhttprequest',
                'EIQ-Payload': 'true',
            }
        });
    }

    const isBestPrice = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('utm_campaign') === 'SmsAnaneoseonBestPrice'
            || urlParams.get('source') === 'bestprice'
            || CheckoutLinkService().isCheckoutLink()
    }

    const isReqAI = () => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('source') === 'reqai'
    }

    if(!isPanelIFrame()){
        data.value = retrieveUserConfiguration(window.location.hostname.replace('www.', '').split('.')[0])
    }

    return {
        isIm,
        isPro,
        getNetworkType,
        getNetworkName,
        isProTheme,
        isPanelIFrame,
        isBestPrice,
        apiInstance,
        data,
        isReqAI
    }

});